import { isPlainObject } from 'is-plain-object';
import { Operation, Editor } from 'slate';
import { cloneDeep } from 'lodash-es';

var OpsLog = {
  /**
   * Check if a value is an `OpsLog` object.
   */
  isOpsLog: function isOpsLog(value) {
    return isPlainObject(value) && Array.isArray(value.ops) && (value.ops.length === 0 || Operation.isOperationList(value.ops));
  }
};

/**
 * Weakmaps for attaching state to the editor.
 */

var LOG = /*#__PURE__*/new WeakMap();
var MERGING = /*#__PURE__*/new WeakMap();
var OpsLogEditor = {
  /**
   * Check if a value is an `OpsLogEditor` object.
   */
  isOpsLogEditor: function isOpsLogEditor(value) {
    return OpsLog.isOpsLog(value.log) && Editor.isEditor(value);
  },

  /**
   * Get the merge flag's current value.
   */
  isMerging: function isMerging(editor) {
    return MERGING.get(editor);
  },

  /**
   * Apply a series of changes inside a synchronous `fn`, without merging any of
   * the new operations into previous save point in the history.
   */
  withoutMerging: function withoutMerging(editor, fn) {
    var prev = OpsLogEditor.isMerging(editor);
    MERGING.set(editor, false);
    fn();
    MERGING.set(editor, prev);
  }
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/**
 * The `withOpsLog` plugin holds all operations applied to a Slate editor.
 *
 * If you are using TypeScript, you must extend Slate's CustomTypes to use
 * this plugin.
 *
 * See https://docs.slatejs.org/concepts/11-typescript to learn how.
 */

var withOpsLog = function withOpsLog(editor) {
  var e = editor;
  var apply = e.apply;
  e.log = {
    ops: [],
    currentBatchIdx: 0
  };

  e.apply = function (op) {
    var operations = e.operations,
        log = e.log;
    var ops = log.ops,
        currentBatchIdx = log.currentBatchIdx;

    var copy = _extends({}, cloneDeep(op), {
      timestamp: Date.now(),
      batchIdx: currentBatchIdx
    });

    var merge = OpsLogEditor.isMerging(e);

    if (merge == null) {
      if (operations.length !== 0) {
        merge = true;
      } else {
        merge = false;
      }
    }

    if (!merge) {
      e.log.currentBatchIdx += 1;
      copy.batchIdx = e.log.currentBatchIdx;
    }

    ops.push(copy);
    apply(op);
  };

  return e;
};

export { LOG, MERGING, OpsLog, OpsLogEditor, withOpsLog };
//# sourceMappingURL=slate-ops-log.esm.js.map
